// Generated by ReScript, PLEASE EDIT WITH CARE

import UnitAutocompleteBindJs from "./UnitAutocomplete.bind.js";

var make = UnitAutocompleteBindJs;

export {
  make ,
  
}
/* make Not a pure module */
